import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import c from 'classnames'
import './index.scss'

const Menu = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  const goTo = path => history.push(path)

  return (
    <div className='headerCenter'>
      <ul className='tabs'>
        <div
          onClick={() => goTo('/troubled')}
          className={c('wrapper', 'troubled', pathname === '/troubled' && 'activeTroubled')}
        >
          <li className='activeTabs'>
            <h4 className='title'>Troubled</h4>
          </li>
        </div>

        <div
          onClick={() => goTo('/')}
          className={c('wrapper', pathname === '/' && 'active' || pathname === '/sign-up/first-session' && 'active')}
        >
          <li className='activeTabs'>
            <h4 className='title'>All stories</h4>
          </li>
        </div>

        <div
          onClick={() => goTo('/empowered')}
          className={c('wrapper', 'empowered', pathname === '/empowered' && 'activeEmpowered')}
        >
          <li className='activeTabs'>
            <h4 className='title'>Empowered</h4>
          </li>
        </div>
      </ul>
    </div>
  )
}

export default Menu
